export enum CompilationTargetId {
  all = "all",
  browser = "browser",
  es6 = "es6",
  node = "node",
  other = "other",
  python3 = "python3"
}
